import { Controller } from "@hotwired/stimulus"
import { setClass } from "../lib/helpers"

export default class extends Controller {
  static targets = ["thumb"]
  static values = {
    state: Array,
    baseClass: String,
    pendingDisabledClass: String,
    pendingEnabledClass: String,
    pendingIssueClass: String,
    disabledClass: String,
    enabledClass: String,
    issueClass: String
  }

  connect() {
    this.form = this.element.closest("form")
    this.button = this.form.querySelector("button[type=submit]")
    this.boundUpdateThumbState = this.updateThumbState.bind(this)
    this.boundOnSubmit = this.onSubmit.bind(this)
    this.boundOnSubmitEnd = this.onSubmitEnd.bind(this)
    this.thumbTarget.addEventListener("turbo:morph-element", this.boundUpdateThumbState)
    this.form.addEventListener("turbo:submit-start", this.boundOnSubmit)
    this.form.addEventListener("turbo:submit-end", this.boundOnSubmitEnd)
  }

  disconnect() {
    this.thumbTarget.removeEventListener("turbo:morph-element", this.boundUpdateThumbState)
    this.form.removeEventListener("turbo:submit-start", this.boundOnSubmit)
    this.form.removeEventListener("turbo:submit-end", this.boundOnSubmitEnd)
  }

  onSubmit(event) {
    this.button.disabled = true
    this.stateValue = ["pending", ...this.stateValue]
  }

  onSubmitEnd(event) {
    if (event?.detail?.success === false) {
      this.stateValue = [this.stateValue[1]]
      this.button.disabled = false
    }
  }

  stateValueChanged() {
    this.updateThumbState()
  }

  hasState(...states) {
    for (const index in states)
      if (!this.stateValue.includes(states[index])) return false

    return true
  }

  updateThumbState() {
    setClass(this.thumbTarget, this.stateClasses)
  }

  get stateClasses() {
    if (this.hasState("pending", "disabled"))
      return [this.baseClassValue, this.pendingDisabledClassValue]
    if (this.hasState("pending", "enabled"))
      return [this.baseClassValue, this.pendingEnabledClassValue]
    if (this.hasState("pending", "issue"))
      return [this.baseClassValue, this.pendingIssueClassValue]
    if (this.hasState("disabled"))
      return [this.baseClassValue, this.disabledClassValue]
    if (this.hasState("enabled"))
      return [this.baseClassValue, this.enabledClassValue]
    if (this.hasState("issue"))
      return [this.baseClassValue, this.issueClassValue]

    return []
  }
}
